export const getOAuthUrl = () => {
  const baseUrl = (process.env.REACT_APP_OAUTH_URL ?? '').trim()
  const params = new URLSearchParams({
    response_type: 'code',
    client_id: (process.env.REACT_APP_CLIENT_ID ?? '').trim(),
    redirect_uri: (process.env.REACT_APP_OAUTH_REDIRECT_URI ?? '').trim(),
    scope: (process.env.REACT_APP_SCOPE ?? '').trim(),
  })

  return `${baseUrl}?${params}`
}
